// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
